module.exports = __webpack_public_path__ + "static/media/crazy-eights-no-ideas.68f9a395.png";